import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "antd";
import { AiOutlineSend } from "react-icons/ai";
import {
  Searchbar,
  Simplecontainer,
  TextContainer,
  StyledInput,
  SearchButton,
  ContentContainer,
  SingleChat,
  UserChatInfoContainer,
  Property,
} from "./Style";
import { FaSearch } from "react-icons/fa";
import UserAvatar from "../../globalComponents/UserAvatar";
import MessagesContainer from "./components/MessagesContainer";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getChatConversations } from "../../store/chats/actions";
import MessageLoading from "./components/MessageLoading";
import { IMyChats } from "../../store/chats/chat.interface";
import { conversationSelector } from "../../store/chats";

const Text = () => {
  const [chatroom_id, setChatroom_id] = useState<number | null>(null);
  const dispatcher = useAppDispatch();
  const chatState = useAppSelector((state) => state.textChat.myChats);
  const isChatLoading = useAppSelector(
    (state) => state.textChat.isChatsLoading
  );

  useEffect(() => {
    dispatcher(getChatConversations());
    return () => {};
  }, []);

  const chatStateSorter = (myChats: IMyChats[]) => {
    const sortedChat = [] as any;
    const myMap = {} as any;
    let sortedArray = [] as any;
    myChats.forEach((e, index: number) => {

      const newDate =
        new Date(e.last_message[0]?.created_at)?.getTime() || Date.now();
      // console.log("milliseconds",newDate.)
      myMap[String(newDate)] = e;
    });
    sortedArray = Object.keys(myMap)?.sort(function (a: any, b: any) {
      console.log("the a ", a, "then", b);
      return +b - +a;
    });

    sortedArray.forEach((e: any) => {
      sortedChat.push(myMap[e]);
    });
    return sortedChat;
  };

  const chatList = useMemo(
    () =>
      chatStateSorter(chatState).map((chat: any) => (
        <SingleChat
          key={`${chat.created_at}`}
          onClick={() => setChatroom_id(chat.id)}
        >
          {console.log("my chat", chat)}
          <UserAvatar username={chat.name} lastname={chat.name} size={45} />
          <div style={{ marginLeft: 10 }}>
            {console.log("chat", chat)}
            <h3 className="title-regular">{chat.name}</h3>
            <h5>{chat?.last_message?.[0]?.message || ""}</h5>
          </div>
        </SingleChat>
      )),
    [chatState]
  );
  const getRoomInfo = useAppSelector((state) =>
    state.textChat.myChats.filter((data) => data.id === chatroom_id)
  );
  console.log("info from here", getRoomInfo);
  return (
    <TextContainer>
      <Row style={{ height: "100%" }} justify="space-between">
        <div style={{ height: "100%", background: "red", minWidth: "400px" }}>
          <Simplecontainer>
            <Searchbar>
              <div>
                <StyledInput
                  style={{ boxShadow: "none" }}
                  bordered={false}
                  placeholder="search..."
                />
                <SearchButton>
                  <FaSearch />
                </SearchButton>
              </div>
            </Searchbar>
            <ContentContainer>
              {isChatLoading && <MessageLoading />}
              {chatList}
            </ContentContainer>
          </Simplecontainer>
        </div>
        <MessagesContainer chatroom_id={chatroom_id} />
        <UserChatInfoContainer>
          <UserAvatar
            img={getRoomInfo[0]?.user[0]?.photolink}
            username={getRoomInfo[0]?.name}
            size={150}
          />
          <Property>
            <h4>Name:</h4> <h4>{getRoomInfo[0]?.name}</h4>
          </Property>
          <Property>
            <h4>Country:</h4>{" "}
            <h4>{getRoomInfo[0]?.user[0]?.currentCountry.country}</h4>
          </Property>
          <Property>
            <h4>City:</h4>{" "}
            <h4>{getRoomInfo[0]?.user[0]?.currentCountry.city}</h4>
          </Property>
        </UserChatInfoContainer>
      </Row>
    </TextContainer>
  );
};

export default Text;
